import { wethToken } from "./tokens";
import { arbLendingPools, goerLendingPools } from "./internalAddresses";
import { ALL_TOKENS } from "./externalAddresses";
import { SupportedChainId } from "./chains";
import weth from "../../images/eth-token.png";

const ARBITRUM_POOLS = [
  {
    lendingPoolAddress: arbLendingPools.WETH,
    ...wethToken,
    tokenAddress: ALL_TOKENS[SupportedChainId.ARBITRUM_ONE].WETH,
    deployedChainId: SupportedChainId.ARBITRUM_ONE,
    tokenUrl: weth,
  },
];

const GOERLI_POOLS = [
  {
    lendingPoolAddress: goerLendingPools.WETH,
    ...wethToken,
    tokenAddress: ALL_TOKENS[SupportedChainId.GOERLI].WETH,
    deployedChainId: SupportedChainId.GOERLI,
    tokenUrl: weth,
  },
];

export const ALL_POOLS: { [key: number]: PoolProps[] } = {
  [SupportedChainId.ARBITRUM_ONE]: ARBITRUM_POOLS,
  [SupportedChainId.GOERLI]: GOERLI_POOLS,
};

export type PoolProps = {
  lendingPoolAddress: string;
  tokenSymbol: string;
  tokenFullName: string;
  tokenDecimal: number;
  tokenAddress: string;
  deployedChainId: number;
  tokenUrl: string;
};
